<template>
	<div>
		<modalDetail :dialog="dialog" :detailResponseApi="detailResponseApi" @hideDialog="() => { dialog = false }"></modalDetail>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="px-4 pb-1">
					<v-row>
						<v-col cols="12" md="4">
							<v-menu v-model="responseDatetime" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(datetime)" label="Tanggal" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
								</template>
								<v-date-picker locale="id" range color="primary" v-model="datetime"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Kode" v-model="code.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="4" >
							<v-autocomplete :items="['POST', 'GET']" outlined dense hide-details label="Tipe" v-model="responseApiType.value"></v-autocomplete>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Endpoint" v-model="responseApiEndpoint.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Parameter" v-model="responseApiParams.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="4" >
							<v-text-field outlined dense hide-details label="Response" v-model="responseApiResponse.value"></v-text-field>
						</v-col>
					</v-row>
				</v-col>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
					<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
				</v-card-actions>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="responseApiData" :search="search" hide-default-footer :options.sync="option" :server-items-length="responseApiPagination.total_data" class="table-w-150">
				<template v-slot:item.response_api_datetime="{ item }">
					<div class="">{{ item.response_api_datetime | tanggaljam }}</div>
				</template>
				<template v-slot:item.response_api_endpoint="{ item }">
					<div class="">{{ item.response_api_endpoint }}</div>
				</template>
				<template v-slot:item.response_api_params="{ item }">
					<div class="">{{ item.response_api_params | toOneLine }}</div>
				</template>
				<template v-slot:item.response_api_status_code="{ item }">
					<div class="">{{ item.response_api_status_code }}</div>
				</template>
				<template v-slot:item.response_api_result="{ item }">
					<div class="">{{ item.response_api_result | toOneLine }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="getDetail(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-text-box-search</v-icon>
							</v-btn>
						</template>
						<span>Detail</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div> </div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!responseApiPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="responseApiPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="responseApiPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalDetail from '@/views/MLwarehouse/responseApi/ResponseApiDetail'

export default {
	inject: ['theme'],
	components: {
		modalDetail
	},
	data() {
		return {
			detailResponseApi: {},
			messages: '',
			propDelete: '',
			page: 1,
			sortBy: 'response_api_datetime',
			sortDir: 'DESC',
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			paramProp: '',
			paramDelid: '',
			paramDelName: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			responseDatetime: false,
			datetime: [],
			search: '',
			headers: [
			{ text: 'Aksi', value: 'action', sortable: false, },
			{ text: 'Tanggal', value: 'response_api_datetime', sortable: true, align: 'start', width: '15%'},
			{ text: 'Kode', value: 'response_api_status_code', sortable: false, width: '5%'},
			{ text: 'Tipe', value: 'response_api_type', sortable: true, align: 'start', width: '5%'},
			{ text: 'Endpoint', value: 'response_api_endpoint', sortable: false},
			{ text: 'Parameter', value: 'response_api_params', sortable: false},
			{ text: 'Respon', value: 'response_api_result', sortable: false},
			],
			code: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'response_api_status_code'
			},
			responseApiDatetime: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'response_api_datetime'
			},
			responseApiType: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'response_api_type'
			},
			responseApiEndpoint: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'response_api_endpoint'
			},
			responseApiParams: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'response_api_params'
			},
			responseApiResponse: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'response_api_result'
			},
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('responseApi', ['responseApiData', 'responseApiPagination']),
	},
	methods: {
		...mapActions('responseApi', ['getResponseApiEcommerce', 'setDetailResponseApi']),
		...mapMutations('responseApi', ['clearDataResponseApi']),

		getData() {
			this.getResponseApiEcommerce(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		getDetail(item) {
			this.setDetailResponseApi(item).then(()=> {
				this.detailResponseApi = item
				this.dialog = true
			})
		},
		cari() {
			this.params= []

			if(this.code.value)
				this.params.push(this.code)

			if (this.responseApiDatetime.value) {
				if (this.responseApiDatetime.value.length > 1) {
					this.responseApiDatetime.value.sort()
					let date = this.responseApiDatetime.value.join('::')
					this.responseApiDatetime.value = date
				}
				this.params.push(Object.assign({}, this.responseApiDatetime))
			}

			if(this.responseApiType.value)
				this.params.push(this.responseApiType)

			if(this.responseApiEndpoint.value)
				this.params.push(this.responseApiEndpoint)

			if(this.responseApiParams.value)
				this.params.push(this.responseApiParams)

			if(this.responseApiResponse.value)
				this.params.push(this.responseApiResponse)

			this.page = 1
			this.getData()
		},
		resetFilter() {
			this.datetime = []
			this.responseApiType.value = ''
			this.responseApiEndpoint.value = ''
			this.responseApiParams.value = ''
			this.responseApiResponse.value = ''
			this.code.value = ''
			this.params = []
			this.limit = 10
			this.getData()
		},
	},
	created() {
		this.getData()
		this.$store.dispatch('setPageTitle', `Response API`);
	},
	beforeDestroy(){
		this.clearDataResponseApi()
	},
	watch: {
		datetime(val) {
			this.responseApiDatetime.value = val
		},
		page() {
			this.getData()
		},
		limit() {
			this.page = 1
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>